<template>
  <div class="c-refine">
    <div class="c-refine__wrap f-ITC-BoldIt" @click="trigger">
      <div class="c-refine__wrapCurrent"><span v-html="currentCate"></span><template v-if="params.tags"><span class="isSlash">/</span><span v-html="currentTag"></span></template></div>
      <span class="c-refine__arrow"></span>
    </div>

    <transition name="c-refine__list">
    <div v-if="$store.getters.isShowRefine" class="c-refine__list">
      <div class="c-refine__listCates f-ITC-BoldIt">
        <ul>
          <li><a :class="{'isSelected': cateSelected('ALL')}" :href="`/${params.post_type}/`">ALL</a></li>
          <li v-for="(c, index) in params.categories" :key="index">
            <a :class="{'isSelected': cateSelected(c.name)}" :href="c.url">{{c.name}}</a>
          </li>
        </ul>
      </div>
      <div v-if="params.tags && params.tags.length > 0" class="c-refine__listTags">
        <div class="c-refine__listTags__wrap">
          <a :class="{'isSelected': tagSelected(t.name)}" v-for="(t, index) in params.tags" :key="index" :href="t.url" v-html="t.name"></a>
        </div>
      </div>
      <div class="c-refine__listClose" @click="close">
        <div class="c-refine__listClose__cross">
          <span></span>
          <span></span>
        </div>
      </div>
    </div>
    </transition>
  </div>
</template>

<script>
  import { assets_path } from '@/_modules/utils/variables'
  import store from '@/_modules/stores';

  export default {
    data() {
      return {
        assets_path: assets_path,
        params: {},
        currentCate: "",
        currentTag: ""
      }
    },
    store,
    computed: {
    },
    mounted() {
      this.params = JSON.parse(document.getElementById('js-param-refine').textContent);

      if (this.params.current.category === 'ALL') {
        this.currentCate = "CATEGORY";
      } else {
        this.currentCate = this.params.current.category;
      }

      if (!this.params.current.tag || this.params.current.tag.length === 0) {
        this.currentTag = "TAG";
      } else {
        this.currentTag = this.params.current.tag;
      }

    },
    methods: {
      trigger() {
        if (this.$store.getters.isShowRefine) {
          this.$store.commit('setShowRefine', false);
        } else {
          this.$store.commit('setShowRefine', true);
        }
      },
      close() {
        this.$store.commit('setShowRefine', false);
      },
      cateSelected(name) {
        if (this.params.current.category === name) {
          return true;
        } else {
          return false;
        }
      },
      tagSelected(name) {
        if (this.params.current.tag === name) {
          return true;
        } else {
          return false;
        }
      }
    }
  }
</script>
